export interface JoinOpts {
  displayName: string;
  shipId: string;
  /** Specific room ID to join. Null → joinOrCreate (dev URL-param fallback). */
  roomId: string | null;
}

export let pendingJoin: JoinOpts | null = null;

export function setPendingJoin(opts: JoinOpts): void {
  pendingJoin = opts;
}
